<template>
<div v-show="isModalVisible">
<div class="modal-mask" @click="closeModal">
      <div class="modal-container" @click.stop>
      <!-- Modal Header -->
      <div class="modal-header">
        <h6 class="modal-title">Settings</h6>
        <button type="button" class="close" data-dismiss="modal" @click="closeModal">&times;</button>
      </div>
      <!-- Modal body -->
      <div class="modal-body">

                <div class="row align-items-center mb-3">
                  <div class="col-12" style="padding-right: 15px;">
                    <div class="px-2">
                      <div class="row">
                        <div class="col-6" >


                            <div class="dropbox1">
                              <div class="row">
                                <div class="col-12 text-left pt-1 bold">
                                  Logo: 
                                </div>
                                <div v-if="logoName != ''" class="col-10 " style="padding-top: 0px; padding-left: 30px;">
                                  <img class="" :src="apiUrl + '/web/site_logo/' + logoName"  />
                                </div>
                              </div>
                            </div>
                        </div>

                        <div class="col-6" >
                          <div class="row">
                            <div class="col-12 text-left pt-1 bold">
                              Color code: 
                            </div>
                            <div class="col-12 datepicker-custom">
                              <div style="width: 25px; height: 25px;" :style="'background-color:' + buttonColorCode + ';'">
                                &nbsp;
                              </div>                            
                            </div>
                          </div>

                          <div class="row pt-3">
                            <div class="col-12 text-left pt-1 bold">
                              Custom link: 
                            </div>
                            <div class="col-12 datepicker-custom">
                              {{ subDomain }}
                            </div>
                          </div>
                        </div>



                      </div>
                    </div>
                  </div>
                </div>

                <div class="row pt-1">
                <div class="col-12 text-align-right pt-1">
                  <textarea
                  name="remarks" 
                  v-model="remarks"
                  @keyup='charCount()'
                  placeholder="Remarks"
                  class="textarea col-xs-12 col-md-12 col-lg-12 padding-lr-5 input-height-25"
                  maxlength="500" style="height: 61px; resize: none;">
                  </textarea>
                  <div class="text-align-right">Characters left: {{ totalcharacter }}</div>
                  
                </div>
                </div>

                <div class="row pt-4">
                <div class="col-6 text-left">
                    <button type="submit" class="btn btn-sm closeBtn" @click="onSubmit('Denied')">Deny</button>
                </div>
                <div class="col-6 text-right">
                    <button v-if="status != 'Denied'" type="submit" class="btn btn-sm ma-blue-btn mr-3" @click="openPreivewModal()">Preview</button>
                    <button type="submit" class="btn btn-sm ma-blue-btn" @click="onSubmit('Approved')">Approve</button>
                </div>
                </div>

        

     </div>
     </div>

</div>
        <BrandingPreviewModal 
          :isModalVisible="isBrandingPreviewModalVisible" 
          :accountId="accountId"
          @close="closePreviewModal"
          ref="branding_preview">
        </BrandingPreviewModal>


</div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import VeeValidate from 'vee-validate';
import axios from 'axios';
import { store } from '../../store/store';
import router from '../../router/index.js';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

import BrandingPreviewModal from './enterprise_lookup_branding_setting_preview.vue';

export default {
  props: [
    'isModalVisible',
    'accountId',
    ],
  data() {
    return {
        loading: false,
        mentee_submit_comment_selected: false,
        menteeId: '',
        submit_comment_checked: 0,
        index: '',
        logoName: '',
        buttonColorCode: '',
        subDomain: '',
        apiUrl: '',
        primaryUserId: '',
        isBrandingPreviewModalVisible: false,
        totalcharacter: 500,
        remarks: '',
        status: '',
    }
  },
  components: {
    BrandingPreviewModal
  },
  methods: {
    charCount: function() {
      this.totalcharacter = parseInt(500) - parseInt(this.remarks.length);
    },
    closePreviewModal() {
      this.switchUserLogout();
      this.isBrandingPreviewModalVisible = false;
    },
    switchUserLogout: function() {
      this.$store.dispatch('switch_user', '');
      this.$store.dispatch('switch_admin_user', '');
      this.$store.dispatch('active_tab', '');
      this.$store.dispatch('set_enterprise_type', '');
      document.documentElement.style.setProperty('--main-bg-color', '#00ACEE');
      this.$logoName = 'MM-logo.png';
      var userLocationObj = {
          isUserLinkedMultipleLocations: false,
          locations: [],
          current: {},
      };
      this.$store.dispatch('set_user_accountid', '');
      this.$store.dispatch('set_user_locations', userLocationObj);
      this.$store.dispatch('set_multi_user_logged_time', '');

    },
    closeModal() {
      this.$validator.errors.clear();
      this.$emit('close');
    },
    onSubmit(status) {
      axios('/desktop/update-sub-domain-status/' + this.accountId, {
         method: 'PATCH',
         data: { 
          "status": status,
          "remarks": this.remarks,
         },

      })
      .then(resp => {
        this.closeModal();
      })
      .catch(error => {
        this.uploadError = error.response.data.message;
      })
    },


    openPreivewModal: function() {
      this.isBrandingPreviewModalVisible = true;
      this.$refs.branding_preview.getBrandingPreviewDetail(this.primaryUserId);
    },

    getBrandingDetail() {        
      axios('/desktop/get-account-color-code-logo/' + this.accountId,
      {
        method: 'GET',
      })
      .then(resp => {
          this.logoName = resp.data.logoName;
          this.buttonColorCode = resp.data.buttonColorCode;
          this.subDomain = resp.data.subDomain;
          this.primaryUserId = resp.data.primaryUserId;
          this.status = resp.data.status;
      })
      .catch(() => {
      });

    },

    navigate(){
        this.$router.push(this.$router.currentRoute.fullPath)
        this.$router.go();
    }
  },
  created() {
    this.apiUrl = process.env.API_ENDPOINT;
  },
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s ease;
  overflow-y: scroll;
}
.modal-container {
  position: fixed;
  left: 50%;
  top: 50%;
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 600px;
  height: auto;
  overflow-y: auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
}
.modal-body {
  margin: 0px;
  padding: 10px;
}
.modal-header .sub-heading {
  background-color: #FFF;
  color: #555;
}
.modal-header {
  padding: 5px;
}
.modal-header .close {
  margin: -1.5rem -2rem -1rem auto;
}
.history-table-wrapper {
  height: 350px;
  overflow-y: auto;
}
.modal-footer {
  border-top: none;
}
.btn-danger {
  background-color: #00ACEE;
  border-color: #00ACEE;
}
.modal-title {
  color: #7d7d7d;
  font-size: 14px;
  font-weight: 900;
}
.modal-header {
  border-bottom: 0px;
  margin-bottom: 10px;
}
.modal-body {
  padding: 5px;
}
.ma-blue-btn, .ma-blue-btn:hover, .ma-blue-btn:focus  {
  color: #FFF !important; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  border-radius: 0 !important;
  font-weight: 900;
  padding: 5px 25px;
}
.form-control { font-size: 14px; }
.hide_vmessage {
  display: none !important;
}
.show_vmessage {
  display: block !important;
}
@media (min-width: 320px) and (max-width: 991px) { 
  .modal-container {
    width: 100%;
  }
}
.ma-reset-password-btn, .ma-reset-password-btn:focus, .ma-reset-password-btn:active, .ma-reset-password-btn:hover {
  color: #FFF !important;
  background: #00ACEE !important;
  border: 1px solid #00ACEE !important;
  min-height: 35px;
  margin-top: -5px;
}
.closeBtn, .closeBtn:hover, .closeBtn:focus {
  color: #00ACEE; 
  background-color: #FFF !important;
  border: 1px solid #00ACEE !important;
  border-radius: 0;
  font-weight: 900;
  padding: 5px 20px;
}

</style>



// WEBPACK FOOTER //
// src/components/admin/enterprise_lookup_branding_setting_display.vue